export default __webpack_public_path__ + "static/media/Emily 9781843629559.5ef7b7bc.jpg";